// extracted by mini-css-extract-plugin
export default {"guidesTitle":"AuthorDetailsContent-module__guidesTitle-CbEP","divider":"AuthorDetailsContent-module__divider-iiO9","guidesGrid":"AuthorDetailsContent-module__guidesGrid-Obv8"};